import React from 'react'
import classNames from 'classnames'
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'
import styles from './answers.module.scss'

export const ItemContent = ({ item }) => (
  item?.url ? <img src={item.url} alt="" loading="lazy" /> : <span>{item?.text}</span>
)

// state: 'selected' | 'correct' | 'wrong' | 'missed' | undefined
function Tile({ state, marker, compact, children, className, ...rest }) {
  return (
    <button
      type="button"
      className={classNames(styles.tile, state && styles[state], { [styles.compact]: compact }, className)}
      {...rest}
    >
      {marker !== undefined && <span className={styles.marker}>{marker}</span>}
      <span className={styles.content}>{children}</span>
      {(state === 'correct' || state === 'missed') && <AiOutlineCheck className={styles.status} size={18} />}
      {state === 'wrong' && <AiOutlineClose className={styles.status} size={18} />}
    </button>
  )
}

export default Tile
